import { Platform } from 'react-native';
import { useAppContext } from '../contexts/AppContext';
import { apiService } from '../services/api';
import { Notification } from '../components/NotificationItem';
import { openNotificationTarget } from '../navigation/notificationRouter';

/** Click-routing + mark-as-read logic for a single notification — extracted
 * from NotificationHistoryScreen.tsx so both that full screen (native +
 * mobile-web) and the desktop-web NotificationsDropdown share one source of
 * truth for "what happens when you click a notification" instead of two
 * independently-drifting copies of this ~130-line switch. */
export function useNotificationActions(setNotifications: React.Dispatch<React.SetStateAction<Notification[]>>) {
  const { navigateTo } = useAppContext();

  const handleNotificationPress = async (notification: Notification) => {
    try {
      if (!notification.read) {
        await apiService.authenticatedRequest(
          `/api/notifications/${notification._id}/read`,
          { method: 'PUT' }
        );
        setNotifications(prev =>
          prev.map(n => n._id === notification._id ? { ...n, read: true } : n)
        );
      }

      await openNotificationTarget(navigateTo, notification.clickAction, notification.data);
    } catch (error) {
      console.error('❌ [useNotificationActions] Error handling notification press:', error);
    }
  };

  return { handleNotificationPress };
}
